import { useEffect, useState } from 'react';
import style from '../../styles/checkoutPopup.module.css';
import { CheckIcon } from '@heroicons/react/24/solid';
import earthIcon from '../../assets/images/earthIcon.webp';
import networkIcon from '../../assets/images/networkIcon.webp';
import markIcon from '../../assets/images/markIconSmall.webp';
import trustLogos from '../../assets/images/newTrustMobile.webp';
import exitIcon from '../../assets/images/Group 17.webp'
import { CheckoutService } from '../../services/CheckoutService';

const CheckoutPopup = ({ closePopup, country, carrier, trial, confrmed, userData }) => {

    const [userCountry, setUserCountry] = useState('');
    const [network, setNetwork] = useState('');
    const [trackingCompatible, setTrackingCompatible] = useState('');
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [price, setPrice] = useState('');
    const [oldPrice, setOldPrice] = useState('');
    const [priceId, setPriceId] = useState('');


    useEffect(() => {
        setTimeout(() => { setUserCountry(country) }, 1000);
        setTimeout(() => { setNetwork(carrier) }, 2000);
        setTimeout(() => { setTrackingCompatible(confrmed) }, 3000)
        if (userData) {
            setTimeout(() => { setIsConfirmed(true) }, 4000);
        } else {
            setTimeout(() => { setIsConfirmed(true) }, 750);
        }
    }, [carrier, country, confrmed, userData]);

    useEffect(() => {
        const onInit = async () => {
            let data = await CheckoutService.getSinglePackage();
            let price = data.prices[0];
            setPriceId(price.id);
            setPrice(price.label);
            setOldPrice(CheckoutService.priceLabel(price.amount * 2, price.currency));
        }
        onInit();

    }, [trial]);

    return (
        <div className={style.popup}>
            {userData ?
                <>
                    <div className={style.dismissContainer} id='topPopup'>
                        <div className={style.dismiss} onClick={closePopup}><img src={exitIcon} alt="exit_Icon" /></div>
                    </div>
                    <div className={style.headerContainer}>
                        <h1 className={style.header}>Moblie information:</h1>
                    </div>
                    <div className={style.verificationContainer}>
                        {userCountry && <div className={style.verificationResult}>
                            <div className={style.resultBlock}><img src={earthIcon} alt="earth_Icon" /><p >Location:</p></div><span className={style.result}>{userCountry}</span>
                        </div>}
                        {network && <div className={style.verificationResult}>
                            <div className={style.resultBlock}><img src={networkIcon} alt="Network_Icon" /><p >Network:</p></div><span className={style.result}>{network}</span>
                        </div>}
                        {trackingCompatible && <div className={style.verificationResult}>
                            <div className={style.resultBlock}><img src={markIcon} alt="mark_Icon" /><p style={{ color: '#F15223' }}>Tracking available:</p></div><span className={style.resultNetwork}>{trackingCompatible}</span>
                        </div>}
                    </div>
                    {isConfirmed &&
                        <div>
                            <div className={style.buttonContainer}>
                                <button className={style.startTrackingButton} onClick={() => CheckoutService.initStripeSession(priceId,trial)}>Start Tracking Now</button>
                            </div>
                            <div className={style.priceContainer}>
                                <div className={style.halfPriceBox}>
                                    <p className={style.halfPrice}>LIMITED TIME 50% OFF</p>
                                </div>
                                <div style={{ marginLeft: '0px' }}>
                                    <p style={{ marginBottom: '10px', marginTop: '10px' }}><span className={style.newPrice}>{price}</span> /month</p>
                                    <p className={style.oldPrice}>Normally {oldPrice} / month</p>
                                </div>
                            </div>
                            <div className={style.trustLogosContainer}>
                                <img src={trustLogos} alt="trust_payment_method_banner" className={style.trustLogo} />
                            </div>
                        </div>
                    }
                </> :
                <div className={style.dismissContainer} id='topPopup'>
                    <div className={style.dismiss} onClick={closePopup}><img src={exitIcon} alt="exit_Icon" />
                    </div>
                    <div>
                        <div className={style.priceContainer}>
                            <div className={style.halfPriceBox}>
                                <p className={style.halfPrice}>LIMITED TIME 50% OFF</p>
                            </div>
                            <div style={{ marginLeft: '0px' }}>
                                <p style={{ marginBottom: '10px', marginTop: '10px' }}><span className={style.newPriceOrange}>{price}</span> /month</p>
                                <p className={style.oldPrice}>Normally {oldPrice} / month</p>
                            </div>
                        </div>
                        <div className={style.buttonContainer}>
                            <button className={style.startTrackingButton} onClick={() => CheckoutService.initStripeSession(priceId, trial)}>Start Tracking Now</button>
                        </div>

                        <div className={style.featureContainer}>
                            <ul className={style.featureList}>
                                <li >
                                    <CheckIcon className={style.featureIcon} /><p className={style.feature}>Track <span className="hightLightText">5</span> devices at once</p>
                                </li>
                                <li>
                                    <CheckIcon className={style.featureIcon} /><p className={style.feature}><span className="hightLightText">Unlimited</span> tracking</p>
                                </li>
                                <li >
                                    <CheckIcon className={style.featureIcon} /><p className={style.feature}>Up to <span className="hightLightText">30 days</span> location history</p>
                                </li>
                                <li >
                                    <CheckIcon className={style.featureIcon} /><p className={style.feature}>Track <span className="hightLightText">Apple & Android</span></p>
                                </li>
                                <li >
                                    <CheckIcon className={style.featureIcon} /><p className={style.feature}>Works on <span className="hightLightText">all networks</span></p>
                                </li>
                            </ul>
                        </div>
                        <div className={style.trustLogosContainer}>
                            <img src={trustLogos} alt="trust_payment_method_banner" className={style.trustLogo} />
                        </div>
                    </div>
                </div>}
        </div>
    );
}
export default CheckoutPopup;